import React from 'react';
const bonuses = [{
  title: 'Bono #1 – Mini-Curso de Mantenimiento Preventivo',
  desc: 'Prácticas reales, paso a paso. Ideal para aplicar en solo 10 minutos.',
  value: 'USD $19',
  img: 'https://cdn.magicpatterns.com/uploads/3Li8yviHkjeWo24L14nW6U/stBebQ4310055.webp'
}, {
  title: 'Bono #2 – Guía, 25: Ruidos, y, Fallas, del, Auto, " (PDF)',
  desc: 'Aprendé a interpretar sonidos y detectar problemas antes que nadie.',
  value: 'USD $15',
  img: 'https'
}, {
  title: 'Bono #3 – Registro de Mantenimiento del Vehículo',
  desc: 'Formato digital e imprimible para llevar todo bajo control.',
  value: 'USD $12',
  img: 'https://cdn.magicpatterns.com/uploads/tjqReayBWqfz6tZCdxpJcL/gvHYcp5098312.webp'
}];
export function BonusesSection() {
  return <section className="bg-gray-900 text-white py-16 px-4" data-id="element-3">
      <div className="max-w-5xl mx-auto" data-id="element-4">
        <div className="text-center mb-12" data-id="element-5">
          <span className="text-yellow-400 font-bold tracking-widest uppercase mb-2 block" data-id="element-6">
            Regalos Exclusivos
          </span>
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-7">
            🎁 BONOS ESPECIALES –{' '}
            <span className="text-yellow-400" data-id="element-8">GRATIS HOY</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-9">
            Solo disponibles para quienes tomen acción ahora
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-10">
          {bonuses.map((bonus, idx) => <a key={idx} href="#pricing" className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700 hover:border-yellow-500 transition-all group" data-id="element-11">
              <div className="w-full" style={{
            aspectRatio: '1/1'
          }} data-id="element-12">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" width={1080} height={1080} data-id="element-13" />
              </div>
              <div className="p-6" data-id="element-14">
                <div className="flex justify-between items-center mb-3" data-id="element-15">
                  <span className="text-xs font-bold bg-yellow-500 text-black px-2 py-1 rounded uppercase" data-id="element-16">
                    Gratis
                  </span>
                  <span className="text-gray-400 line-through text-sm" data-id="element-17">
                    Valor: {bonus.value}
                  </span>
                </div>
                <h3 className="font-bold text-lg mb-2 text-white group-hover:text-yellow-400 transition-colors" data-id="element-18">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-19">{bonus.desc}</p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}